/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:23]
Permissions to update outside the main branch: [false]
*/

const timeFormat = 'HH:mm';
const timeWithSecondsFormat = timeFormat + ':ss';
const dateFormat = 'yyyy-MM-dd';
const datetimeFormat = dateFormat + "'T'" + timeFormat;
const datetimeWithSecondsFormat = dateFormat + "'T'" + timeWithSecondsFormat;

export { timeFormat, dateFormat, datetimeFormat, datetimeWithSecondsFormat, timeWithSecondsFormat };
